<template>
    <div>
        <el-tabs class="common-el-tabs" type="card">
            <el-tab-pane label="AT">
                <comp-club-at class="common-el-tab-flex"/>
            </el-tab-pane>
            <el-tab-pane label="MT">
                <comp-club-mt class="common-el-tab-flex"/>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>
<script>
    import compClubAt from './compClubAT'
    import compClubMt from './compClubMT'

    export default {
        components: {
            compClubAt,
            compClubMt
        }
    }
</script>

